import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { IconClose, IconDone, IconInformation } from '@klarna/bubble-ui';

import { selectors as configSelectors } from 'mage-config';
import { translator } from 'mage-i18n';
import { Alert, LoaderIcon } from 'moet-core';

import { PRE_ASSESSMENT_STATUSES } from '@/constants';
import { getMerchantIdFromWidgetCookie } from '@/selectors/widget';
import { merchantRegion } from '@/selectors/merchant';

const tPrefix = 'products-fe.containers.pre_assessment_overview.status';

const BANNER_MAP = {
  [PRE_ASSESSMENT_STATUSES.APPROVED]: { icon: IconDone, type: 'success' },
  [PRE_ASSESSMENT_STATUSES.REJECTED]: { icon: IconClose, type: 'error' },
  [PRE_ASSESSMENT_STATUSES.UNRESOLVED]: { icon: LoaderIcon, type: 'default' },
  [PRE_ASSESSMENT_STATUSES.STARTED]: { icon: LoaderIcon, type: 'default' },
  TIMED_OUT_UNRESOLVED: { icon: IconInformation, type: 'default' },
};

const Component = ({ underwritingStatus, t, mid, environment, region }) => {
  const [banner, setBanner] = useState(BANNER_MAP[underwritingStatus]);
  const [data, setData] = useState({
    content: t(`${tPrefix}.${underwritingStatus}`),
    label: undefined,
    link: undefined,
  });

  useEffect(() => {
    setBanner(BANNER_MAP[underwritingStatus]);
    setData({
      content: t(`${tPrefix}.${underwritingStatus}`),
      label: undefined,
      link: undefined,
    });

    if (underwritingStatus === PRE_ASSESSMENT_STATUSES.UNRESOLVED) {
      const timeoutId = setTimeout(() => {
        setBanner(BANNER_MAP.TIMED_OUT_UNRESOLVED);
        setData({
          content: t(`${tPrefix}.UNRESOLVED_TIMED_OUT`),
          label: t(`${tPrefix}.UNRESOLVED_TIMED_OUT_LINK_LABEL`),
          /* eslint-disable-next-line max-len */
          link: `https://merchant-gui-${region}.${environment}.c2c.klarna.net/underwriting?query=${mid}`,
        });
      }, 15000);

      return () => clearTimeout(timeoutId);
    }
  }, [underwritingStatus]);

  return (
    <Alert
      icon={banner?.icon}
      type={banner?.type}
      content={data.content}
      linkLabel={data.label}
      onLinkClick={() => data.link && window.open(data.link)}
    />
  );
};

Component.propTypes = {
  environment: PropTypes.string.isRequired,
  mid: PropTypes.string.isRequired,
  region: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  underwritingStatus: PropTypes.oneOf(Object.keys(PRE_ASSESSMENT_STATUSES)),
};

Component.displayName = 'PreAssessmentStatusAlert';

export const PreAssessmentStatusAlert = connect(state => ({
  environment: configSelectors.environment(state),
  mid: getMerchantIdFromWidgetCookie(state),
  region: merchantRegion(state),
  t: translator(state),
}))(Component);
